/**
 * 知识点地图节点定义
 *
 * 每个节点：
 *   id          - 唯一标识
 *   label       - 显示名称
 *   x / y       - SVG 坐标（viewBox: "0 0 520 300"）
 *   questionIds - 归属此节点的题目 ID 列表
 *
 * 新增题目后，将题目 ID 追加到最相关节点的 questionIds 中。
 */

// ── 読解（reading）10 个节点 ─────────────────────────

const readingNodes = [
  {
    id: 'reading-keigo',
    label: '高级敬语体系',
    x: 148, y: 82,
    questionIds: [1, 2, 3, 21, 22, 23, 24, 25, 26, 27],
  },
  {
    id: 'reading-biz1',
    label: '商务句型·基础',
    x: 258, y: 135,
    questionIds: [4, 5, 6, 7, 8],
  },
  {
    id: 'reading-biz2',
    label: '商务句型·扩展',
    x: 375, y: 122,
    questionIds: [28, 29, 30, 31, 32, 33, 34, 35, 36],
  },
  {
    id: 'reading-vocab1',
    label: '词汇辨析·基础',
    x: 143, y: 205,
    questionIds: [9, 10, 11, 12, 13],
  },
  {
    id: 'reading-vocab2',
    label: '词汇辨析·扩展',
    x: 268, y: 228,
    questionIds: [37, 38, 39, 40, 41, 42, 43, 44],
  },
  {
    id: 'reading-doc',
    label: '商务文书写作',
    x: 408, y: 72,
    questionIds: [53, 54, 55, 56, 57],
  },
  {
    id: 'reading-j3',
    label: 'J3 基础语法',
    x: 65, y: 258,
    questionIds: [85, 86, 87, 88, 89],
  },
  {
    id: 'reading-j1plus',
    label: 'J1+ 高级句型',
    x: 456, y: 55,
    questionIds: [90, 91, 92],
  },
  {
    id: 'reading-condition',
    label: '条件与让步句型',
    x: 398, y: 210,
    questionIds: [93, 94, 95, 96, 100],
  },
  {
    id: 'reading-finance',
    label: '财务与交涉词汇',
    x: 460, y: 275,
    questionIds: [97, 98, 99],
  },
];

// 连线（[from_id, to_id]），仅用于装饰，不影响逻辑
const readingConnections = [
  ['reading-j3',        'reading-vocab1'],
  ['reading-vocab1',    'reading-biz1'],
  ['reading-keigo',     'reading-biz1'],
  ['reading-biz1',      'reading-biz2'],
  ['reading-biz2',      'reading-doc'],
  ['reading-biz2',      'reading-j1plus'],
  ['reading-doc',       'reading-j1plus'],
  ['reading-vocab1',    'reading-vocab2'],
  ['reading-vocab2',    'reading-condition'],
  ['reading-condition', 'reading-finance'],
];

// ── 聴解（listening）5 个节点 ─────────────────────────

const listeningNodes = [
  {
    id: 'listening-pragmatic1',
    label: '社会语用·建前本音',
    x: 248, y: 110,
    questionIds: [14, 15, 65, 69],
  },
  {
    id: 'listening-pragmatic2',
    label: '社会语用·间接信号',
    x: 385, y: 85,
    questionIds: [48, 73],
  },
  {
    id: 'listening-reception',
    label: '接待与日常礼节',
    x: 112, y: 158,
    questionIds: [61, 62, 66, 67, 68],
  },
  {
    id: 'listening-phone',
    label: '电话通话管理',
    x: 108, y: 262,
    questionIds: [70, 71, 72, 74],
  },
  {
    id: 'listening-strategy',
    label: '口头会话策略',
    x: 318, y: 218,
    questionIds: [45, 46, 47, 63, 64],
  },
];

const listeningConnections = [
  ['listening-pragmatic1', 'listening-pragmatic2'],
  ['listening-pragmatic1', 'listening-strategy'],
  ['listening-reception',  'listening-phone'],
  ['listening-reception',  'listening-pragmatic1'],
];

// ── 聴読解（listeningReading）8 个节点 ───────────────

const listeningReadingNodes = [
  {
    id: 'lr-meeting',
    label: '会议主持·推进',
    x: 132, y: 92,
    questionIds: [16, 79],
  },
  {
    id: 'lr-objection',
    label: '表达遗憾与异议',
    x: 92, y: 205,
    questionIds: [17, 18, 77],
  },
  {
    id: 'lr-criticism',
    label: '接受批评·应对',
    x: 255, y: 155,
    questionIds: [19, 52, 83],
  },
  {
    id: 'lr-pragmatic',
    label: '社会语用·立场区分',
    x: 400, y: 95,
    questionIds: [20, 60, 78],
  },
  {
    id: 'lr-logic',
    label: '逻辑接续·总结',
    x: 252, y: 72,
    questionIds: [49, 50, 75, 81],
  },
  {
    id: 'lr-context',
    label: '语境判断·省略推断',
    x: 390, y: 218,
    questionIds: [51, 76],
  },
  {
    id: 'lr-finance',
    label: '专业词汇·财务贸易',
    x: 442, y: 268,
    questionIds: [58, 59, 80],
  },
  {
    id: 'lr-workplace',
    label: '职场礼节·接待',
    x: 298, y: 268,
    questionIds: [82, 84],
  },
];

const listeningReadingConnections = [
  ['lr-meeting',   'lr-objection'],
  ['lr-meeting',   'lr-logic'],
  ['lr-logic',     'lr-pragmatic'],
  ['lr-criticism', 'lr-pragmatic'],
  ['lr-criticism', 'lr-context'],
  ['lr-context',   'lr-finance'],
  ['lr-workplace', 'lr-criticism'],
];

// ── 导出 ─────────────────────────────────────────────

export const mapNodes = {
  reading:          readingNodes,
  listening:        listeningNodes,
  listeningReading: listeningReadingNodes,
};

export const mapConnections = {
  reading:          readingConnections,
  listening:        listeningConnections,
  listeningReading: listeningReadingConnections,
};
